import {Button, Stack, Link as Link2} from '@chakra-ui/react';
import {motion} from 'framer-motion';
import React, {useState} from 'react';
import {Link, useSearchParams} from 'react-router-dom';
import {HomeOptionsLink} from '../../../constants/hom-options';

const MotionedStack = motion(Stack);

const Navbar = ({scrollToTop}) => {
    const [searchParams] = useSearchParams();
    const param = searchParams.get('ca') || 'Featured';
    const [show, setShow] = useState(true);

    React.useEffect(() => {
        const handler = (e, a) => {
            if (window.scrollY > 29 && show === false) {
                setShow(true);
            }
            /*
            if (window.scrollY < 29 && show) {
                setShow(false);
            }
            */
        };

        window.addEventListener('scroll', handler);
        return () => {
            window.removeEventListener('scroll', handler);
        };
    }, [setShow, show]);

    return (
        <>
            <MotionedStack
                zIndex={10000000000000}
                direction={'row'}
                borderRadius={'full'}
                mx={'auto'}
                maxWidth={['361px', '461px', '600px']}
                w={'full'}
                bg={'white'}
                position={'fixed'}
                bottom={show ? '50px' : '-46px'}
                initial={{
                    bottom: show ? '50px' : '-46px',
                }}
                animate={{
                    bottom: show ? '50px' : '-46px',
                }}
                left={'0'}
                right={'0'}
                height={{base: '41px', lg: '55px'}}
                alignItems={'center'}
                p={'5px 6px'}
                overflow={'scroll'}
                sx={{
                    MsOverflowStyle: 'none' /* IE and Edge */,
                    scrollbarWidth: 'none' /* Firefox */,
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                }}
                spacing={[0, 1]}
            >
                {HomeOptionsLink.map((item, key) => {
                    return (item.href.substring(0,4) == 'http' ? 
                        <Link2 
                            href={`${item.href}`} 
                            target={`_blank`}
                            sx={{
                                px: ['10px', '20px'],
                            }}
                            fontSize={['8px', '10px', '13px']}
                            key={key}
                            display={'flex'}
                            as={Link2}
                            isExternal
                            whiteSpace={'nowrap'}
                            textDecoration={'none'}
                            >
                                {item.title}
                        </Link2>
                        :
                        <Button
                            sx={{
                                px: ['10px', '20px'],
                            }}
                            fontSize={['8px', '10px', '13px']}
                            key={key}
                            isActive={param === item.title} 
                            display={'flex'}
                            as={Link}
                            to={`/${item.href}`}
                            height={{base: '30px', lg: '45px'}}
                            onClick={() => scrollToTop()}
                        >
                            {item.title}
                        </Button>
                    );
                })}
            </MotionedStack>
        </>
    );
};

export default Navbar;
